export const CWJ_WORKSPACE_VERSION = "0.1.0";
export const DEFAULT_STORAGE_KEY = "smart_shikka_cwj_workspace";
export const DEFAULT_PROJECT_ID = "smart-print";
export const DEFAULT_SKILL_ID = "smart-print-audit";
export const CWJ_WORKSPACE_VIEWS = [
    "inbox",
    "active",
    "approval",
    "review",
    "qa",
    "completed",
    "failed",
    "paused",
    "all",
];
/** Keys whose values must never be written to persistent storage. */
export const SECRET_KEYS = [
    "password",
    "secret",
    "token",
    "apiKey",
    "api_key",
    "bearer",
    "authorization",
    "privateKey",
    "private_key",
];
export const VIEW_LABELS = {
    inbox: { en: "Inbox", hi: "इनबॉक्स" },
    active: { en: "Active", hi: "सक्रिय" },
    approval: { en: "Approval", hi: "मंजूरी" },
    review: { en: "Review", hi: "समीक्षा" },
    qa: { en: "QA", hi: "QA" },
    completed: { en: "Completed", hi: "पूर्ण" },
    failed: { en: "Failed", hi: "विफल" },
    paused: { en: "Paused", hi: "रुका हुआ" },
    all: { en: "All", hi: "सभी" },
};
//# sourceMappingURL=constants.js.map